import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { LoanAgreementLineCreateInput, LoanAgreementLineUpdateInput } from '@libs/types/src/mado/input-type';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { LoanAgreementLineGridObject, LoanAgreementLineObject } from '@libs/types/src/mado/object-type/loan-agreement-line.object';

@Injectable({ providedIn: 'root' })
export class LoanAgreementLineGqlService extends GqlServiceV2 {

    public getLoanAgreementLines(input: GridInput | null, frag: string) {
        return this.query<LoanAgreementLineGridObject>(
            `
                query($input: GridInput!) {
                    loanAgreementLine {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createLoanAgreementLine(input: LoanAgreementLineCreateInput, frag: string) {
        return this.mutate<LoanAgreementLineObject>(
            `
                mutation($input: LoanAgreementLineCreateInput!) {
                    loanAgreementLine {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateLoanAgreementLine(input: LoanAgreementLineUpdateInput, frag: string) {
        return this.mutate<LoanAgreementLineObject>(
            `
                mutation($input: LoanAgreementLineUpdateInput!) {
                    loanAgreementLine {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteLoanAgreementLine(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    loanAgreementLine {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
